import { module } from 'angular';
import { UserModel } from './model/user';

/* @ngInject */
const userFactory = (
	$filter,
	$location,
	$uibModalStack,
	$rootScope,
	$timeout,
	$translate,
	Notification,
	Reset,
) => {
	const userModel = new UserModel(
		$filter,
		$location,
		$uibModalStack,
		$rootScope,
		$timeout,
		$translate,
		Notification,
		Reset,
	);

	userModel.startListeners();
	return userModel;
};

export default module('app').factory('User', userFactory);
